<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("MESSAGES.add new branch") }}</h4>
    </div>
      <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #405950">
        <i
          :class="
            $i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'
          "
        ></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <div class="col-12">
            <!-- <v-btn class="add_branch_btn" @click="addBranch">
              <i class="fas fa-plus"></i> {{ $t("PLACEHOLDERS.add_branch") }}
            </v-btn> -->
          </div>

          <div class="branch_item row">
            <div class="col-lg-6 cl-12">
              <base-input
                col="12"
                type="text"
                :placeholder="$t('MESSAGES.branch_name_ar')"
                v-model.trim="branch.name_ar"
              />
            </div>
            <div class="col-lg-6 cl-12">
              <base-input
                col="12"
                type="text"
                :placeholder="$t('MESSAGES.branch_name_en')"
                v-model.trim="branch.name_en"
              />
            </div>

            <div class="col-lg-6 cl-12">
              <base-input
                col="12"
                type="textarea"
                :placeholder="$t('MESSAGES.branch_description_ar')"
                v-model.trim="branch.description_ar"
              />
            </div>
            <div class="col-lg-6 cl-12">
              <base-input
                col="12"
                type="textarea"
                :placeholder="$t('MESSAGES.branch_description_en')"
                v-model.trim="branch.description_en"
              />
            </div>

            <div class="col-lg-12 cl-12">
              <base-input
                col="12"
                type="textarea"
                :placeholder="$t('MESSAGES.address')"
                v-model.trim="branch.address"
              />
            </div>
            <div class="col-12 mb-3 input_wrapper top_label select_wrapper">
              <GmapAutocomplete
                @place_changed="setPlace"
                @keyup.enter.stop="setPlace"
                :placeholder="$t('MESSAGES.search_place')"
              />
            </div>
            <div class="col-12">
              <gmap-map
                :center="branch.location"
                :zoom="12"
                style="width: 100%; height: 300px"
                @click="setLocation($event, index)"
              >
                <gmap-marker :position="branch.location" />
              </gmap-map>
            </div>
            <!-- <div class="col-12 text-end">
              <v-btn class="remove_branch_btn" @click="removeBranch(index)">
                <i class="fas fa-minus"></i>
                {{ $t("PLACEHOLDERS.delete_branch") }}
              </v-btn>
            </div> -->
          </div>
        </div>

        <div class="btn_wrapper">
          <base-button
            class="mt-2"
            styleType="primary_btn"
            :btnText="$t('BUTTONS.save')"
            :isLoading="isWaitingRequest"
            :disabled="isWaitingRequest"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "StoreBranches",
  data() {
    return {
      isWaitingRequest: false,
      branch: {
        name_ar: "",
        name_en: "",
        description_ar: "",
        description_en: "",
        address: "",
        location: { lat: 24.7136, lng: 46.6753 }, // Default location (e.g., Riyadh)
      },
      cities: [],
    };
  },
  methods: {
    addMarker() {
      if (this.currentPlace) {
        this.branch.location.lat = this.currentPlace.geometry.location.lat();
        this.branch.location.lng = this.currentPlace.geometry.location.lng();

        this.Latitude = this.currentPlace.geometry.location.lat();
        this.Longitude = this.currentPlace.geometry.location.lng();

        this.center.lat = this.currentPlace.geometry.location.lat();
        this.center.lng = this.currentPlace.geometry.location.lng();
        this.currentPlace = null;
      }
    },
    addBranch() {
      this.branches.push({
        name_ar: "",
        name_en: "",
        description_ar: "",
        description_en: "",
        location: { lat: 24.7136, lng: 46.6753 },
      });
    },
    removeBranch(index) {
      this.branches.splice(index, 1);
    },
    setLocation(event, index) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      
      this.branch.location = {
        lat: lat,
        lng: lng,
      };

      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          this.branch.address = results[0].formatted_address;
        } else {
          this.branch.address = '--';
        }
      });
      
    },
    setPlace(place) {
      this.currentPlace = place;
      this.addMarker();
    },
    validateFormInputs() {
      this.submitForm();
    },
    async submitForm() {
      this.isWaitingRequest = true;

      const REQUEST_DATA = new FormData();

      // Basic fields

      REQUEST_DATA.append("name[ar]", this.branch.name_ar);
      REQUEST_DATA.append("name[en]", this.branch.name_en);
      REQUEST_DATA.append("description[ar]", this.branch.description_ar);
      REQUEST_DATA.append("description[en]", this.branch.description_en);
      REQUEST_DATA.append("lat", this.branch.location.lat);
      REQUEST_DATA.append("lng", this.branch.location.lng);
      REQUEST_DATA.append("address", this.branch.address);

      try {
        await this.$axios({
          method: "POST",
          url: `festival-providers/${this.$route.params.id}/branches`,
          data: REQUEST_DATA,
        });
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.$router.push({
          path: `/festival-providers/departments/${this.$route.params.id}`,
        });
      } catch (error) {
        this.$message.error(error.response.data.message);
      } finally {
        this.isWaitingRequest = false;
      }
    },

    // Start:: Get Data To Edit
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `stores/${this.$route.params.id}/social`,
        });
        // Start:: Set Data
        // Transform the API response
        this.phones = res.data.data.Social?.mobile?.map((phone) => ({
          phone: phone,
        })) || [{ phone: "" }];
        this.data.WhatsApp_contact = res.data.data.Social?.whatsapp;
        this.data.twitter = res.data.data.Social?.x;
        this.data.tiktok = res.data.data.Social?.tiktok;
        this.data.instagram = res.data.data.Social?.instagram;
        this.data.facebook = res.data.data.Social?.facebook;
        this.data.snapchat = res.data.data.Social?.snapchat;

        // End:: Set Data
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data To Edit

    async getCities() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `cities?page=0&limit=0`,
        });
        this.cities = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    this.getCities();
  },
};
</script>

<style scoped>
.branch_item {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
}
.add_branch_btn,
.remove_branch_btn {
  margin: 10px 0;
}
</style>
